export default "__VITE_ASSET__DM7H3Q3x__"